var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 106.999,
    viewBox: "0 0 107 106.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M743.5,60A53.5,53.5,0,1,0,797,113.5,53.519,53.519,0,0,0,743.5,60Zm0,58.85a5.366,5.366,0,0,1-5.35-5.35V92.1a5.35,5.35,0,0,1,10.7,0v21.4A5.366,5.366,0,0,1,743.5,118.85Zm-5.35,10.7v10.7h10.7v-10.7Z",
    transform: "translate(-690 -60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a8bdae360e5a7e836be98ea05fc7db1d.svg";
export { ForwardRef as ReactComponent };